import { createReducer, on } from '@ngrx/store';
import * as TicketsActions from './tickets.actions';
import { SupportTicket } from '../../shared/services/admin/support-tickets.service';

export interface TicketsState {
  tickets: SupportTicket[];
  selectedTicket: SupportTicket | null;
  total: number;
  page: number;
  pageSize: number;
  loading: boolean;
  error: any;
  lastFilter: {
    status?: string;
    page?: number;
    pageSize?: number;
  } | null;
}

export const initialState: TicketsState = {
  tickets: [],
  selectedTicket: null,
  total: 0,
  page: 1,
  pageSize: 20,
  loading: false,
  error: null,
  lastFilter: null,
};

export const reducer = createReducer(
  initialState,
  on(TicketsActions.loadTickets, (state, { status, page, pageSize }) => ({
    ...state,
    loading: true,
    error: null,
    lastFilter: { status, page, pageSize },
  })),
  on(TicketsActions.loadTicketsSuccess, (state, { response }) => ({
    ...state,
    tickets: response.tickets || [],
    total: response.total || 0,
    page: response.page || 1,
    pageSize: response.page_size || 20,
    loading: false,
    error: null,
  })),
  on(TicketsActions.loadTicketsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(TicketsActions.loadTicketById, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TicketsActions.loadTicketByIdSuccess, (state, { ticket }) => ({
    ...state,
    selectedTicket: ticket,
    loading: false,
    error: null,
  })),
  on(TicketsActions.loadTicketByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(TicketsActions.updateTicketStatus, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TicketsActions.updateTicketStatusSuccess, (state, { ticket }) => ({
    ...state,
    tickets: state.tickets.map((t) => (t.id === ticket.id ? ticket : t)),
    selectedTicket: state.selectedTicket?.id === ticket.id ? ticket : state.selectedTicket,
    loading: false,
    error: null,
  })),
  on(TicketsActions.updateTicketStatusFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(TicketsActions.clearTickets, (state) => ({
    ...state,
    tickets: [],
    selectedTicket: null,
    total: 0,
    lastFilter: null,
  })),
);
